
import { FormState__setValidationResponse_5219762A, CustomerConfiguration, FormState_get_empty, RequestedValue$1 } from "../../../Shared/Shared.js";
import { Msg, State } from "./Types.js";
import { updateCustomerConfiguration, getCustomerConfiguration } from "../../../Requests/Configuration.js";
import { Cmd_batch, Cmd_none } from "../../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { Cmd_successToast, Cmd_errorToast } from "../../../Components/Toast.js";
import { ofArray } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";

export const initialState = new State(new RequestedValue$1(0, []), new RequestedValue$1(0, []), FormState_get_empty());

export function init() {
    return [initialState, getCustomerConfiguration((Item) => (new Msg(1, [Item])), (Item_1) => (new Msg(4, [Item_1])))];
}

export function update(msg, state) {
    switch (msg.tag) {
        case 2: {
            const matchValue = state.CustomerConfiguration;
            if (matchValue.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                const customerConfiguration = matchValue.fields[0];
                const matchValue_1 = state.Currency;
                if (matchValue_1.tag === 0) {
                    return [state, Cmd_none()];
                }
                else {
                    return [state, updateCustomerConfiguration(new CustomerConfiguration(customerConfiguration.Staging, customerConfiguration.IsGlobalAppSearchActiveForUserRole, customerConfiguration.IsStorageSelfServiceUserAuthorisedToReturnToolsWithoutNotification, customerConfiguration.IsSelfServiceReservationForUserActive, customerConfiguration.ReceiverVisibilityConfiguration, customerConfiguration.NotificationEmailsOnlyToAdministrators, customerConfiguration.DemoDataImported, customerConfiguration.CanUserSeeAllTools, customerConfiguration.CanUserWriteNotices, customerConfiguration.AppVisibilityPermissionReceiver, customerConfiguration.GlobalSelfServiceStorageActive, customerConfiguration.CustomI18nextNamespace, customerConfiguration.Tenants, customerConfiguration.TenantName, customerConfiguration.ReceiverCreateReservationAllowedConfiguration, customerConfiguration.AllowUserToUserAssignmentViaUserSelection, customerConfiguration.IsUserToUserTransferSignatureRequired, customerConfiguration.IsReturnTransferSignatureRequired, customerConfiguration.IsReleaseDateEnabled, customerConfiguration.ToolManagerCanCreateReceiver, customerConfiguration.ToolManagerCanArchiveReceiver, customerConfiguration.SSOConfiguration, customerConfiguration.InventoryConfiguration, customerConfiguration.ProtocolConfiguration, customerConfiguration.AppLogoConfiguration, customerConfiguration.ReservationConfiguration, matchValue_1.fields[0], customerConfiguration.ChatActive, customerConfiguration.CompletedOnboardingTourSteps), (Item) => (new Msg(3, [Item])), (Item_1) => (new Msg(4, [Item_1])))];
                }
            }
        }
        case 1: {
            const response = msg.fields[0];
            return [new State(new RequestedValue$1(1, [response]), new RequestedValue$1(1, [response.Currency]), state.FormState), Cmd_none()];
        }
        case 3: {
            const response_1 = msg.fields[0];
            if (response_1.tag === 1) {
                return [new State(state.CustomerConfiguration, state.Currency, FormState__setValidationResponse_5219762A(state.FormState, response_1.fields[0])), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(state.CustomerConfiguration, state.Currency, FormState_get_empty()), Cmd_batch(ofArray([Cmd_successToast("general.saved_successfully"), getCustomerConfiguration((Item_2) => (new Msg(1, [Item_2])), (Item_3) => (new Msg(4, [Item_3])))]))];
            }
        }
        case 4:
            return [state, Cmd_none()];
        default:
            return [new State(state.CustomerConfiguration, new RequestedValue$1(1, [msg.fields[0]]), state.FormState), Cmd_none()];
    }
}

